import { ProductTypeEnum } from "@jasper/client-models";

export default {
  common: {
    yes: "Oui",
    no: "Non",
    validate: "Valider",
    validated: "Validé",
    toProvide: "À renseigner",
    invalidValue: "Valeur invalide",
    dateFormat: "DD/MM/YYYY",
  },
  products: {
    [ProductTypeEnum.bridge]: "Bridge",
    [ProductTypeEnum.crown]: "Couronne",
    [ProductTypeEnum.splintedCrown]: "Couronne solidarisée",
  },
  components: {
    teethSelect: {
      title: "Sélectionnez les dents",
      legends: {
        toothNumbering: "Numérotation FDI · ISO 3950",
        solidarizedElements: "Éléments solidarisés",
        splittedElements: "Éléments séparés",
        solidarized_one: "Solidarisé",
        solidarized_other: "Solidarisés",
        solidarizationHelp:
          "Cliquez sur le lien entre deux dents voisines pour les solidariser",
        noSolidarization_zero:
          "Toutes les dents sont séparées · aucune jonction possible",
        noSolidarization_one:
          "Toutes les dents sont séparées · une jonction possible",
        noSolidarization_other:
          "Toutes les dents sont séparées · {{count}} jonctions possibles",
      },
      labels: {
        right: "Droite",
        left: "Gauche",
        mandibular: "Mandibulaire",
        maxillary: "Maxillaire",
        tooth: "Dent",
        groupButton: "Solidariser les dents {{firstTooth}} et {{secondTooth}}",
      },
      tooltips: {
        groupButton: "Solidariser les dents sélectionnées",
      },
      buttons: {
        groupAll: "Solidariser tous les groupes",
        dissociateAll: "Désolidariser tous les groupes",
      },
    },
    droppableFileInput: {
      errors: {
        invalidType: "Le fichier {{filename}} n'est pas valide",
        alreadyExists: "Le fichier {{filename}} a déjà été téléchargé",
      },
      labels: {
        input: "Télécharger",
        selectFiles: "Sélectionner des fichiers",
      },
    },
    phoneNumberInput: {
      placeholder: "Entrez un numéro de téléphone",
      countryAriaLabel: "Sélection du pays",
      phoneNumberAriaLabel: "Saisie du numéro de téléphone",
    },
    textAreaWithDroppableFile: {
      errors: {
        invalidType: "Le fichier {{filename}} n'est pas valide",
        alreadyExists: "Le fichier {{filename}} a déjà été téléchargé",
        fileNotUploaded: "Le fichier n'a pas été téléchargé",
      },
      labels: {
        uploadFileButton: "Ajouter un fichier",
      },
      placeholders: {
        textArea: "Entrez du texte",
      },
    },
    userSelect: {
      placeholder: "Sélectionnez un utilisateur",
    },
    saveableCard: {
      save: "Enregistrer",
      saved: "Enregistré",
    },
  },
  forms: {
    address: {
      labels: {
        addressName: "Nom de l'adresse",
        streetNumber: "Numéro de rue",
        streetName: "Nom de rue",
        details: "Informations supplémentaires",
        city: "Ville",
        postalCode: "Code postal",
        country: "Pays",
      },

      tooltips: {
        streetNumber:
          "Le numéro de rue avec le nom de rue doivent comporter moins de 33 caractères",
        streetName:
          "Le numéro de rue avec le nom de rue doivent comporter moins de 33 caractères",
      },
    },

    materialCharacteristics: {
      errors: {
        material: "Veuillez choisir un matériau",
      },
      placeholders: {
        material: "Choisissez un matériau",
      },
      labels: {
        material: "Matériau",
      },
    },

    inlayCoreCharacteristics: {
      errors: {
        hasClavette: "Veuillez indiquer si l'inlay-core est claveté",
        scanPost: "Veuillez choisir un scan post",
        material: "Veuillez choisir un matériau",
      },
      placeholders: {
        scanPost: "Choisissez le scan post utilisé",
        material: "Choisissez un matériau",
      },
      descriptions: {
        clavetedMaterial:
          "Seuls les matériaux compatibles avec un inlay-core claveté sont proposés.",
      },
      labels: {
        hasClavette: "Inlay-core claveté ?",
        scanPostType: "Type de scan post",
        scanPost: "Scan post utilisé",
        material: "Matériau de l'inlay-core",
      },
    },

    shadeCharacteristics: {
      errors: {
        shadeType: "Veuillez choisir un type de teintier",
        shade: "Veuillez choisir une teinte",
      },
      placeholders: {
        shade: "Choisissez une teinte",
      },
      labels: {
        shadeType: "Teintier",
        shade: "Teinte",
        isMultiShade: "Dégradé de teinte",
      },
    },

    multiShadeCharacteristics: {
      errors: {
        incisalShade: "Veuillez choisir une teinte de tiers incisal",
        baseShade: "Veuillez choisir une teinte de tiers médian",
        gingivalShade: "Veuillez choisir une teinte de tiers cervical",
      },
      placeholders: {
        incisalShade: "Choisissez une teinte de tiers incisal",
        baseShade: "Choisissez une teinte de tiers médian",
        gingivalShade: "Choisissez une teinte de tiers cervical",
      },
      labels: {
        incisalShade: "Tiers incisal",
        baseShade: "Tiers médian",
        gingivalShade: "Tiers cervical",
      },
    },

    product: {
      errors: {},
      placeholders: {},
      labels: {
        isPerTooth: "Caractéristiques différentes pour chaque prothèse",
        isPerToothConfirmation: {
          title: "Êtes-vous sûr de vouloir continuer ?",
          message:
            "Si vous continuez, les caractéristiques de chaque prothèse seront réinitialisées.",
          confirm: "Oui",
          cancel: "Annuler",
        },
      },
    },

    orderInfo: {
      labels: {
        dentist: "Praticien",
      },
      placeholders: {
        dentist: "Recherchez un docteur",
      },
      searching: "Recherche...",
      noDentistFound: "Aucun docteur trouvé",
    },
    patient: {
      labels: {
        firstName: "Prénom",
        lastName: "Nom",
        birthDate: "Date de naissance",
        sex: "Sexe",
      },
      sex: {
        MALE: "Homme",
        FEMALE: "Femme",
      },
    },
    implantCharacteristics: {
      subtitles: {
        scanBody: "Scan body",
      },
      descriptions: {
        scanBody:
          'Le scan body nous permet de trouver les librairies de conception 3D de votre fabricant d\'implant. Si vous ne connaissez pas la référence exacte, indiquez les informations que vous avez ou bien "NA".',
      },
      labels: {
        implantBrand: "Marque du système implantaire",
        implantSystem: "Système implantaire",
        implantPlatform: "Plateforme / diamètre",
        scanBody: "Référence utilisée",
        missingReference:
          "Je ne trouve pas la référence de mon système d'implant",
      },
      placeholders: {
        implantBrand: "Choisissez une marque du système implantaire",
        implantSystem: "Choisissez un système implantaire",
        implantPlatform: "Choisissez une plateforme",
        scanBody: "Choisissez la référence",
      },
      errors: {
        implantBrand: "Veuillez choisir une marque du système implantaire",
        implantSystem: "Veuillez choisir un système implantaire",
        implantPlatform: "Veuillez choisir une plateforme",
        scanBody: "Veuillez choisir la référence",
      },
    },
    abutmentCharacteristics: {
      choices: {
        standard: "Standard",
        standardOriginal: "Pilier original - fabriquant",
        standardGeneric: "Pilier standard générique",
        custom: "Personnalisé",
      },
      errors: {
        abutmentType: "Veuillez choisir un type de pilier",
        abutmentPreferences: "Veuillez renseigner vos préférences",
      },
      placeholders: {
        abutmentPreferences: "Renseignez vos préférences",
      },
      labels: {
        abutmentType: "Type de pilier",
        abutmentPreferences: "Préférences pour le pilier",
        standardAbutmentType: "Type de pilier standard",
      },
      descriptions: {
        abutmentPreferences:
          "Si vous avez des préférences particulières de pilier standard (Hauteur de pilier, angulé, etc.)",
      },
    },
    implantedItemCharacteristics: {
      choices: {
        cementRetained: "Scellé",
        screwRetained: "Transvissé",
      },
      errors: {
        retentionType: "Veuillez choisir un type de rétention",
      },
      labels: {
        retentionType: "Type de rétention",
      },
    },
  },
};
